import * as turf from '@turf/turf';
import moment from 'moment';
import wellknown from 'wellknown';
const LayerControls = (name) => require('../../controls').get(name);

import api from '../../api';
import environment from '../../environment';
import layers from '../../layers';
import drawing from '../map/draw';
import translate from '../tools/translate';
import Dialog from './Dialog';
import {loading, unloading} from "../../shared";
import {CustomerSpreadsheet} from "../../../spreadsheets/customer-spreadsheet";
import type {sourceDataCustomerSpreadsheet} from "../../../spreadsheets/customer-spreadsheet";
import _ from "lodash";
import { ContextEnum } from '../../../enuns/context.enum';
class Customers extends Dialog {
    constructor(area) {
        api.general.log.action(ContextEnum.SelectTool, 'Camada de Clientes');
        const contexts: any[] = [
            {label: translate('Common.Customers'), context: 'Customers', mainLayer: true}
        ];

        const shape =
            area.layerType === 'circle'
                ? turf.buffer(area.layer.toGeoJSON(), area.layer.getRadius(), { units: 'meters' })
                : area.layer.toGeoJSON();

        if (turf.area(shape) > 100 * 1000 * 1000 * 1000) {
            alert('Ferramenta de área livre funciona somente para área até 100.000 km².');
            drawing.removeLayer();
            super(translate("Common.Customers"), null);
            return;
        }

        super(translate("Common.Customers"), area, contexts);
        this.rangePicking = true;
        this.saveAsExcel = this.saveAsExcel.bind(this);
    }

    populateLayers(actionRefresh) {
        (this : any).preventMultipleCalls();
        const toggleIncremental = () => {
            if(!!actionRefresh){
                customersLayer.toggleIncrementalFeatures();
            }
        };
        this._features = [];
        const customersLayer = layers.get("Customers");
        const filterPeriod = (this: any).filterPeriod;
         if (customersLayer.visible())
            return new Promise(resolve => {
                this.addToLayers(customersLayer);
                resolve();
            });

        return api.store.get.customers.fromBbox(
            wellknown.stringify(this._shape),
            moment(filterPeriod.start).format('YYYYMM'),
            moment(filterPeriod.end).format('YYYYMM'),
        ).then(res => {
            toggleIncremental();
            customersLayer.setFeatures(res);
            this.addToLayers(customersLayer);
            (this : any).enablePopulateLayers();
            toggleIncremental();
        });
    }

    get calculateTotals(){
       return _((this: any).aggregateBy("IdLoja")).values().sum();
    }

    createDropdownOptions() {
        return [{ text: "Loja", value: "IdLoja" }];
    }

    getNameStore(idStore: number){
        const stores = environment.get("CONFIG.FILTERS.DEALERS_STORES");
        const { Nome } = stores.find(s => s.Id === idStore) || { Nome: 'Desconhecido' };

        return Nome;
    }

    aggregateBy() {
        return this.featuresProperties.reduce((final, obj) => {
            const name = this.getNameStore(obj.IdLoja);

            final[name] = (final[name] || 0) + 1;
            return final;
        }, {});
    }

    saveAsExcel (e) {
        e.preventDefault();
        const objData = this.aggregateBy();
        const data: sourceDataCustomerSpreadsheet = Object.keys(objData)
            .map(x => ({
                nameStore: x,
                qtySales: objData[x]
            }));

        api.general.log.action(ContextEnum.SelectTool, 'Download Excel', JSON.stringify(data));

        loading();
        setTimeout(() => {
            (new CustomerSpreadsheet()).mount(data).create().saveAsExcel();
            unloading();
        }, 300);
    }
}

export default Customers;



// WEBPACK FOOTER //
// ./src/scripts/core/selection/Customers.js